import { render, staticRenderFns } from "./TaskCalendarSetting.vue?vue&type=template&id=db8fb842&scoped=true&"
import script from "./TaskCalendarSetting.vue?vue&type=script&lang=js&"
export * from "./TaskCalendarSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8fb842",
  null
  
)

export default component.exports